import api from "../../components/services/api";
import { useParams } from "react-router";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import "./SaleOrder.css";
export default function STLQuotation() {
  const [data, setData] = useState();

  const pageCount = 1;
  // const pageCount = Math.ceil(data?.detail?.length / 6)
  const rows = [];
  for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
    rows.push(
      <>
        <page>
          <div class="header">
            <img
              src="/images/logo2.png"
              class="logo"
              style={{ width: "130px" }}
            />
            <div className="header_title" style={{width:"100%",}}>
              <h3>SRITRANG LOGISTIC COMPANY LIMITED</h3>
              <div style={{display:"flex", justifyContent:'space-between'}}><h4>บริษัท ศรีตรังโลจิสติกส์ จำกัด</h4><span>Head Quarter:</span></div>
              <div style={{display:"flex", justifyContent:'space-between'}}><span>สำนักงานใหญ่</span><span>136-136/1 Phatthalung Rd, Tubtiang Sub-district,</span></div>
              <div style={{display:"flex", justifyContent:'space-between'}}><span>136-136/1 ถนนพัทลุง ตำบลทับเที่ยง อำเภอเมืองตรัง จังหวัดตรัง 92000</span><span>Amphoe Mueang Trang, Trang, Thailand 92000</span></div>
              <div style={{display:"flex", justifyContent:'space-between'}}><span>เลขทะเบียนนิติบุคคล: 0925550000247</span><span>Tax: 0925550000247</span></div>
            </div>
          </div>
          <div
            class="content"
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              display: "flex",
              justifyContent: "end",
              borderTop: "1px solid #000",
            }}
          >
            <h4>ใบเสนอราคา / Quotation</h4>
          </div>
          <div
            class="content"
            style={{ marginTop: "0px", justifyContent: "space-between" }}
          >
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Service Type:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                Quotation No.:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}> -</p>
            </div>

            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Period:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                Quotation Date:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}> -</p>
            </div>

            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Port of Loading:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                Sale Name:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}> -</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                Port of Discharge:{" "}
              </p>
              <p style={{ flexBasis: "80%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                Tel No.:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}>-</p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "65%" }}>
              <p className="header_p" style={{ flexBasis: "20%" }}>
                {" "}
              </p>
              <p style={{ flexBasis: "80%" }}> </p>
            </div>
            <div className="rowR" style={{ display: "flex", flexBasis: "35%" }}>
              <p className="header_p" style={{ flexBasis: "40%" }}>
                E-Mail:{" "}
              </p>
              <p style={{ flexBasis: "60%" }}> -</p>
            </div>

            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Customer Code:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Customer Name:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Customer Address:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Contract Person:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Tel / Fax No.:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                E-Mail:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%", marginTop: "20px" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Factory Name:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
            <div
              className="rowR"
              style={{ display: "flex", flexBasis: "100%" }}
            >
              <p className="header_p" style={{ flexBasis: "12.5%" }}>
                Commodity:{" "}
              </p>
              <p style={{ flexBasis: "87.5%" }}> {data?.SaleOrderNo || "-"}</p>
            </div>
          </div>

          <div className="containerR">
            <table
              border="1"
              cellpadding="10"
              cellspacing="0"
              style={{ width: "100%" }}
            >
              <tr style={{ border: "1px solid" }}>
                <th style={{ border: "1px solid" }}>Code</th>
                <th style={{ border: "1px solid" }}>Service Description</th>
                <th style={{ border: "1px solid" }}>Size</th>
                <th style={{ border: "1px solid" }}>Quantity</th>
                <th style={{ border: "1px solid" }}>Unit Price</th>
                <th style={{ border: "1px solid" }}>Tax%</th>
                <th style={{ border: "1px solid" }}>Total</th>
                <th style={{ border: "1px solid" }}>Currency</th>
              </tr>

              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }} align="center">
                  {data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.No}
                </td>
                <td style={{ border: "1px solid" }}>
                  {data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.WagonNo}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]
                      ?.ContainerNo_1
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]
                      ?.ContainerNo_2
                  }
                </td>
                <td style={{ border: "1px solid" }} align="center">
                  {data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.Size}
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]
                      ?.Commodity
                  }
                </td>
                <td style={{ border: "1px solid" }}>
                  {
                    data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]
                      ?.Commodity
                  }
                </td>
              </tr>
             
              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td
                  valign="top"
                  rowspan="3"
                  colspan="4"
                  style={{ border: "1px solid" }}
                ></td>
                <td colspan="2" align="center" style={{ border: "1px solid" }}>
                  Total
                </td>
                <td colspan="1" style={{ border: "1px solid" }}>
                  {data?.TotalNoTax}
                </td>
                <td colspan="1" style={{ border: "1px solid" }}>
                  {data?.CurrencyCode}
                </td>
              </tr>
              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td colspan="2" align="center" style={{ border: "1px solid" }}>
                  Tax
                </td>
                <td colspan="1">{data?.TotalTax}</td>
                <td style={{ border: "1px solid" }}>{data?.CurrencyCode}</td>
              </tr>

              <tr style={{ border: "1px solid", fontSize: "16px" }}>
                <td colspan="2" align="center" style={{ border: "1px solid" }}>
                  Total Amount
                </td>
                <td colspan="1">{data?.TotalAmount}</td>
                <td style={{ border: "1px solid" }}>{data?.CurrencyCode}</td>
              </tr>
              <tr height="70px">
                <td
                  valign="top"
                  colspan="8"
                  style={{ fontSize: "16px", borderBottom: "1px solid" }}
                >
                  {`Service Condition:   ${data?.InternalNote || '-'}`}
                </td>
              </tr>
              <tr height="70px">
                <td valign="top" colspan="8" style={{ fontSize: "16px" }}>
                  {`Remark:   ${data?.InternalNote || '-'}`}
                </td>
              </tr>
            </table>
          </div>
          <div
            className="content_footer"
            style={{ justifyContent: "space-between" }}
          >
            <div className="rowR" style={{ flexBasis: "30%" }}>
              <p style={{ lineHeight: "24px" }}>
                ______________________________
              </p>
              <p>(.........................................................)</p>
              <p>Authorized of the Company</p>
              <p>Date.............../.............../...............</p>
            </div>
            <div className="rowR" style={{ flexBasis: "30%" }}>
              <p style={{ lineHeight: "24px" }}>
                ______________________________
              </p>
              <p>(.........................................................)</p>
              <p>Sale</p>
              <p>Date.............../.............../...............</p>
            </div>
            <div className="rowR" style={{ flexBasis: "30%" }}>
              <p style={{ lineHeight: "24px" }}>
                ______________________________
              </p>
              <p>(.........................................................)</p>
              <p>Marketing Manager</p>
              <p>Date.............../.............../...............</p>
            </div>
          </div>
        </page>
      </>
    );
  }
  return <>{rows}</>;
}
